import { Container, useTheme } from "@mui/material";
import { useWindow } from "../../hooks/useWindow";

export const PageContainer = (
  propsWithChildren: React.PropsWithChildren<any>
) => {
  const { children, ...props } = propsWithChildren;
  const theme = useTheme();
  const { height } = useWindow();

  return (
    <Container
      disableGutters
      maxWidth={false}
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",

        minHeight: height
          ? {
              xs:
                height -
                theme.dimensions.headerHeightXs -
                theme.dimensions.footerHeight,
              md:
                height -
                theme.dimensions.headerHeight -
                theme.dimensions.footerHeight,
            }
          : undefined,
      }}
      {...props}
    >
      {children}
    </Container>
  );
};
